import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Link } from '@mui/material';

// project imports
import Logo from 'ui-component/Logo';
import { useSelector } from 'store';

// ==============================|| MAIN LOGO ||============================== //
const LogoSection = () => {
    const { defaultPath } = useSelector((state) => state.auth);

    return (
        <Link component={RouterLink} to={defaultPath || '/'}>
            <Logo />
        </Link>
    );
};

export default LogoSection;
